(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

require('../../../modules/modules');

require('../../../templates/templates');

jQuery(function ($) {
  $(document).ready(function () {

    // adwords cookie tracking
    var gclid = getParam('gclid');
    if (gclid) {
      var gclsrc = getParam('gclsrc');
      if (!gclsrc || gclsrc.indexOf('aw') !== -1) {
        setCookie('gclid', gclid, 90);
      }
    }

    $('.fade-in').each(function () {
      $(this).waypoint(function (d) {
        if (d === 'down' && $(this.element).css('opacity') == 0) {
          $(this.element).velocity({
            opacity: 1,
            translateY: [0, 30]
          }, {
            duration: 500,
            easing: 'easeInOut'
          });
        }
      }, { offset: '80%' });
    });
  });

  $(window).on('load', function () {
    // hubspot cookie tracking
    var userTokenInputs = $('.hs-input[name="user_token"]');
    if (userTokenInputs.length) {
      userTokenInputs.each(function () {
        $(this).val(getCookie('hubspotutk'));
      });
    }

    // adwords cookie tracking
    var googleIdInputs = $('input[name="gclid"]');
    if (googleIdInputs.length) {
      googleIdInputs.each(function () {
        $(this).val(getCookie('gclid'));
      });
    }
  });
});

function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = '; expires=' + date.toGMTString();
  document.cookie = name + '=' + value + expires + ';path=/';
}

function getParam(p) {
  var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

imgix.config.host = 'newmar.imgix.net';
imgix.config.useHttps = true;
imgix.config.defaultParams = {
  auto: 'compress,format',
  crop: 'edges'

  // fix accessibility issues from third party scripts that embed iframes and forms
};jQuery(window).load(function () {
  jQuery('iframe[data-reactid=".hbspt-forms-0.8"]').attr('title', 'HubSpot tracker iframe');
  jQuery('iframe[data-reactid=".hbspt-forms-1.8"]').attr('title', 'HubSpot iframe');
  jQuery('.acsb-navigator-search').append('<input type="submit" style="display:none;" name="submit">');

  // add titles to iframes
  jQuery('iframe').each(function (index) {
    var iframe_name = '';
    if (jQuery(this).attr('title')) {
      // don't do anything
    } else {
      if (jQuery(this).attr('name')) {
        iframe_name = jQuery(this).attr('name');
        jQuery(this).attr('title', iframe_name);
      } else {
        iframe_name = 'Iframe ' + index;
        jQuery(this).attr('title', iframe_name);
      }
    }
  });

  // add text to legends
  jQuery('fieldset').each(function (index) {
    var legend = jQuery(this).find('legend');
    var legend_text = legend.text();
    var label_placeholder = jQuery(this).find('label').attr('placeholder');
    if (legend_text === '' || null) {
      legend.text(label_placeholder);
    }
  });
});

},{"../../../modules/modules":10,"../../../templates/templates":25}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = accordionScrollTop;
jQuery(function ($) {
  $(document).ready(function () {
    accordionScrollTop();
  });
});

function accordionScrollTop() {
  jQuery(function ($) {
    $('.m-accordion-row').on('shown.bs.collapse', function () {
      var panel = $(this).find('.panel.panel-default > .panel-collapse.in'),
          offset = panel.offset();
      if (offset) {
        panel.velocity('scroll', {
          duration: 400,
          offset: -panel.parents('.panel').find('.panel-heading').outerHeight()
        });
      }
    });
  });
}

},{}],3:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $('.m-header-nav-coaches > span').on('click', function () {
    if ($('.m-header-nav-coaches .clearfix').is(':visible')) {} else {
      buildMobileNav(JSON.parse(sessionStorage.getItem("productModels")), null);
    }
  });
  function buildMobileNav(products) {

    var groupBy = function groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };
    var groupedProducts = groupBy(products, 'product_type_name');
    var coachesHtml = '';
    $.each(groupedProducts, function (key, value) {
      coachesHtml = coachesHtml + ('<div class="categoryTitle"><h3>' + key + '</h3></div><div class="productGroup">');
      $.each(value, function (product_key, product) {
        coachesHtml = coachesHtml + ('<div class="product" data-coachid="' + product.id + '">\n      <div class="mobileYearToggle">\n      <div class="productYear ' + (typeof product.secondary === "undefined" ? "singleYear" : "") + '">\n      ' + (typeof product.secondary === "undefined" ? "" : '<div><a href="#" class="productYear__year secondaryProduct" data-modelorder="secondary">' + product.secondary[0].year + '</a></div>') + '\n        <div><a href="#" class="productYear__year productYear__year--active primaryProduct" data-modelorder="primary">' + product.primary[0].year + '</a></div>\n      </div>\n      </div>\n      <div class="product__image">\n      <a class="content__cta" title="" href="' + product.primary[0].page.link + '">\n        <img src="' + product.primary[0].menu_image + '"/>\n        </a>\n      </div>\n      <div class="product__details">\n        <h5 class="">' + product.coach + '</h5>\n        <p class="productPrice__price">Starting at $' + product.primary[0].msrp + '</p>\n      </div>\n      <div class="product__toggle">\n        <div class="icon expandProductIcon"></div>\n      </div>\n      <div class="expandedContent">\n        <div class="video">\n          <div class="video__overlay">\n            <h2 class="modelYear">' + product.primary[0].year + '</h2>\n            <h1>' + product.coach + '</h1>\n            <a class="btn btn-primary video__overlay__cta content__cta" title="" href="' + product.primary[0].page.link + '">Learn More</a>\n          </div>\n          <div class="video__player">\n            <img src="' + product.primary[0].menu_still + '" style="position: absolute;top: 0;right: 0;left: 0;bottom: 0;width:100%;height:100%"/>\n            <video loop muted autoplay poster="' + product.primary[0].menu_still + '" class="video__background" data-videourl="' + product.primary[0].menu_video + '" style="position: absolute;top: 0;right: 0;left: 0;bottom: 0;"></video>\n          </div>\n        </div>\n        <div class="details">\n          <div class="productDetails">\n          <a class="btn btn-primary mobile_cta content__cta" title="product_button" href="' + product.primary[0].page.link + '">Learn More</a>\n            <div class="productYear">\n            ' + (typeof product.secondary === "undefined" ? "" : '<a href="#" class="productYear__year secondaryProduct" data-modelorder="secondary">' + product.secondary[0].year + '</a><span class="productYear__divider"></span>') + '\n              <a href="#" class="productYear__year productYear__year--active primaryProduct" data-modelorder="primary">' + product.primary[0].year + '</a>\n            </div>\n            <div class="productPrice">\n              <span class="productPrice__price">Starting at $' + product.primary[0].msrp + '</span>\n            </div>\n          </div>\n          <div class="productLink">\n            <a href="' + product.primary[0].page.link + 'floorplans" class="productLink__link model-floorplan">Floor plans<span class="underline"></span>\n            </a>\n            <div class="productLink__divider"></div>\n            <a href="' + product.primary[0].page.link + 'brochure" class="productLink__link model-brochure">Brochure<span class="underline"></span>\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>');
      });
      coachesHtml = coachesHtml + '</div>';
    });
    $('.coachMobileLineup').html(coachesHtml);
  }
});

},{}],4:[function(require,module,exports){
"use strict";

jQuery(function ($) {
  $(document).ready(function () {
    getProducts(); //load the products into cache
    var timer; //set the timer var

    //Handle the hover state and mouse movement
    $(document).on({
      mouseenter: function mouseenter() {
        var self = this; // define the current hover object all through the function
        videoPreload(self); // preload video
        //track mousemove
        $(self).on("mousemove", function (e) {
          clearInterval(timer);
          timer = setTimeout(function () {
            triggerHover(self); //trigger the hover state
          }, 200);
        });
      },
      mouseleave: function mouseleave() {
        clearTimeout(timer);
        removeHover(this); // remove the hover state
      }
    }, ".modelNav");
  });
  $('.m-header-nav-coaches > span').on('click', function () {
    if ($('.m-header-nav-coaches .clearfix').is(':visible')) {} else {
      buildCoachFilter(JSON.parse(sessionStorage.getItem("productModels")), null);
      if (typeof hj !== "undefined") {
        hj('trigger', 'model_nav_dropdown');
      }
    }
  });
  function loadVideo(self) {
    var video = $(self).find(".video__background");
    var videoSource = $(video).data("videourl");
    video.html('<source src="' + videoSource + '" type="video/mp4"></source>');
    video.load();
  }
  $(document).on("click", ".expandProductIcon", function () {
    var parent = $(this).parent().parent();
    getProducts(parent);
    loadVideo(parent);
    $(".product--expanded").not(parent).removeClass("product--expanded");
    if (parent.hasClass("product--expanded")) {
      parent.removeClass("product--expanded");
    } else {
      parent.addClass("product--expanded");
    }
  });
  /* Trigger Hover function
      Pass the object that contains the overlay element
  */
  function triggerHover(el) {
    var overlay = $(el).find(".overlayWrapper")[0]; //find the overlay
    if ($(overlay).css('visibility') === "visible") {
      return;
    };
    $(el).find("#jsVideoPlayer").load(); //find the video player and load it
    $(el).find("#jsVideoPlayer").trigger('play');
    //start the fancy transitions
    $(el).css("transform", "translate(0)");
    //show the overlay
    $(overlay).css({
      visibility: "visible",
      opacity: "1"
    });
    //Dim all others
    $(".modelNav").not(el).css({
      filter: "grayscale(1)",
      opacity: ".5"
    });
    //if the item is on the left edge
    if ($(el).data("position") == 1) {
      $(overlay).css({
        transform: "translate(4.75rem)",
        right: "calc(-9.5rem / 2)",
        width: "calc(100% + 9.5rem)"
      });
      $(el).nextAll().css("transform", "translate(9.5rem)");
      // if the item is on the right edge
    } else if ($(el).data("position") == 5) {
      $(overlay).css({
        transform: "translate(-4.75rem)",
        left: "calc(-9.5rem / 2)",
        width: "calc(100% + 9.5rem)"
      });
      $(el).prevAll().css("transform", "translate(-9.5rem)");
      // All others do this
    } else {
      $(overlay).css({
        left: "calc(-9.5rem / 2)",
        right: "calc(-9.5rem / 2)",
        width: "calc(100% + 9.5rem)"
      });
      $(el).prevAll().css("transform", "translate(-4.75rem)");
      $(el).nextAll().css("transform", "translate(4.75rem)");
    }
  }
  function removeHover(el) {
    $(el).find(".overlayWrapper").css({
      visibility: "hidden",
      opacity: "0"
    });
    $(".modelNav").css({
      transform: "translate(0)",
      filter: "grayscale(0)",
      opacity: "1"
    });
  }
  function videoPreload(el) {
    var video = $(el).find("#jsVideoPlayer");
    var videoSource = $(video).data("videourl");
    video.html('<source src="' + videoSource + '" type="video/mp4"></source>');
  }
  function videoUnload(el) {
    var video = $(el).find("#jsVideoPlayer");
    video.html('');
  }
  function getProducts() {
    var modelStore = sessionStorage.getItem("productModels");
    if (modelStore == null) {
      makeAjaxRequest(null);
      /*       makeAjaxRequest(null).done((response) => {
      
            }); */
    }
  }
  function getProduct(id) {
    var product = '';
    var models = null;
    if (models = sessionStorage.getItem("productModels")) {
      product = $.grep(JSON.parse(models), function (n, i) {
        return n.id == id;
      });
    } else {}
    return product;
  }
  function loadFile(filePath) {
    var cacheBust = Date.now();
    filePath = filePath + "?v=" + cacheBust;
    var result = null;
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open("GET", filePath, false);
    xmlhttp.send();
    if (xmlhttp.status == 200) {
      result = xmlhttp.responseText;
    }
    return result;
  }
  function makeAjaxRequest(productID) {
    var env = document.domain.replace(/\./g, '-');
    var file = JSON.parse(loadFile('rev-manifest.json'))[0][env];
    if (file === void 0) {
      file = env;
    }
    var jqxhr = $.getJSON("https://newmar-8c1e.kxcdn.com/" + file, function () {}).done(function (data) {
      sessionStorage.setItem("productModels", JSON.stringify(data));
    }).fail(function () {
      console.log("json request failed");
    });
    if (productID == null) {} else {
      filter = $.grep(JSON.parse(jqxhr), function (n, i) {
        return n.product_type == productType;
      });
      return filter;
    }
  }
  $(".filter.filterByWheelchair").on("click", function (e) {
    e.preventDefault();
    setActive(this);
    $(".productList").addClass("productList--loading");
    if (sessionStorage.getItem("productModels")) {
      var allModels = sessionStorage.getItem("productModels");
      var _filter = null;
      _filter = JSON.parse(allModels);
      _filter = $.grep(JSON.parse(allModels), function (n, i) {
        return n.wheelchair == true;
      });
      buildCoachFilter(_filter, null);
    }
  });
  $(".filter.filterByLength").on("click", function (e) {
    e.preventDefault();
    setActive(this);
    $(".productList").addClass("productList--loading");
    if (sessionStorage.getItem("productModels")) {
      var allModels = sessionStorage.getItem("productModels");
      var _filter2 = null;
      _filter2 = JSON.parse(allModels);
      _filter2.sort(function (x, y) {
        return y.length - x.length;
      });
      buildCoachFilter(_filter2, "length");
    }
  });
  $(".filter.filterByHorsepower").on("click", function (e) {
    e.preventDefault();
    setActive(this);
    if (sessionStorage.getItem("productModels")) {
      $(".productList").addClass("productList--loading");
      var allModels = sessionStorage.getItem("productModels");
      var _filter3 = null;
      _filter3 = JSON.parse(allModels);
      _filter3.sort(function (x, y) {
        return y.hp - x.hp;
      });
      buildCoachFilter(_filter3, "hp");
    }
  });
  $(".sort.topNav__link").on("click", function (e) {
    e.preventDefault();
    setActive(this);
    var productType = $(this).data("typeid");
    if (sessionStorage.getItem("productModels")) {
      $(".productList").addClass("productList--loading");
      var allModels = sessionStorage.getItem("productModels");
      var _filter4 = null;
      if (productType != "all") {
        _filter4 = $.grep(JSON.parse(allModels), function (n, i) {
          return n.product_type == productType;
        });
      } else {
        _filter4 = JSON.parse(allModels);
      }
      buildCoachFilter(_filter4, null);
    }
  });
  function buildCoachFilter(filterData, sort) {
    var counter = 1;
    var product = "";
    $.each(filterData, function (key, value) {
      var isLastElement = key == filterData.length - 1;
      if (counter == 1) {
        product += '<div class="flexbox">';
      }
      product += modelComponent(value, sort, counter, key, 'primary');
      if (counter == 5 || isLastElement) {
        product += "</div>\n        <div class=\"line\"></div>";
        counter = 0;
      }
      counter++;
    });
    $(".modelWrapper").replaceWith('<div class="modelWrapper">' + product + "</div>");
  }
  function modelComponent(value, sort, counter, loop, position) {
    var modelSelector = position == null ? 'primary' : position;
    var html = "\n    <div class=\"col modelNav\" data-position=\"" + counter + "\" style=\"--animation-order: " + loop + ";\">\n    <div class=\"productModel\">\n      <div class=\"topline\">\n        <h5 class=\"text-center coachText\">" + value.coach + "</h5>\n        " + (sort == "hp" ? '<span class="productPrice__price"><b><small>Starting at ' + value.hp + "HP</small></b></span>" : "") + "\n        " + (sort == "length" ? '<span class="productPrice__price"><b><small>Starting at ' + value.length + "ft</small></b></span>" : "") + "\n      </div>\n      <div class=\"productModelImage\"><img class=\"menu_image\" src=\"" + value[modelSelector][0].menu_image + "\"></div>\n\n      <div class=\"bottomline\">\n        <div class=\"modelYear\">\n        " + (typeof value.secondary === "undefined" ? "" : '<a href="' + value.secondary[0].page.link + '" class="modelYear__year secondaryProduct" data-modelorder="secondary">' + value.secondary[0].year + '</a><span class="modelYear__divider"></span>') + "\n          <a href=\"" + value.primary[0].page.link + "\" class=\"modelYear__year modelYear__year--active primaryProduct\" data-modelorder=\"primary\">" + value.primary[0].year + "</a>\n        </div>\n        <div class=\"startPrice\">\n          <span>Starting at $<span class=\"msrp\">" + value[modelSelector][0].msrp + "</span></span>\n        </div>\n      </div>\n    </div>\n    <div class=\"overlayWrapper\" style=\"z-index:5;\">\n      <div\n        class=\"videoWrapper\" style=\"z-index:2;background-image:url('" + value[modelSelector][0].menu_still + "');  background-position: center;background-repeat: no-repeat;background-size: cover;\">\n        <link rel=\"preload\" as=\"video\" id=\"videoPreload\"  href=\"" + value[modelSelector][0].menu_video + "\">\n        <video id=\"jsVideoPlayer\" style=\"\" loop muted data-videourl=\"" + value[modelSelector][0].menu_video + "\"></video>\n        <a href=\"" + value[modelSelector][0].page.link + "\" class=\"overlayContent\">\n          <h2 class=\"coachYear\">" + value.primary[0].year + "</h2>\n          <h1>" + value.coach + "</h1>\n        </a>\n        <a class=\"content__cta\" title=\"\" href=\"" + value[modelSelector][0].page.link + "\">Learn More</a>\n      </div>\n      <div class=\"bottomContent\">\n        <div class=\"model\"><img class=\"menu_image\" src=\"" + value[modelSelector][0].menu_image + "\"></div>\n        <div class=\"cta\">\n          <div class=\"productLink\">\n            <a href=\"" + value[modelSelector][0].page.link + "floorplans\" class=\"productLink__link model-floorplan\">Floor plans<span class=\"underline\"></span>\n            </a>\n          </div>\n            <div class=\"productLink__divider\"></div>\n          <div class=\"productLink\">\n            <a href=\"" + value[modelSelector][0].page.link + "brochure\" class=\"productLink__link model-brochure\">Brochure<span class=\"underline\"></span>\n            </a>\n          </div>\n        </div>\n        <div class=\"pricing\">\n          <div class=\"modelYear\">\n          " + (typeof value.secondary === "undefined" ? "" : '<a href="#" class="modelYear__year secondaryProduct jsSwapModel" data-modelorder="secondary" data-model="' + value.id + '" data-year="">' + value.secondary[0].year + '</a><span class="modelYear__divider"></span>') + "<a href=\"#\" class=\"modelYear__year modelYear__year--active primaryProduct jsSwapModel\" data-modelorder=\"primary\" data-model=\"" + value.id + "\" data-year=\"\">" + value.primary[0].year + "</a>\n          </div>\n          <div class=\"startPrice\">\n            <span>Starting at $<span class=\"msrp\">" + value[modelSelector][0].msrp + "</span></span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n    ";
    return html;
  }
  /* Year Swapping */
  $(document).on("click", ".jsSwapModel", function (e) {
    e.preventDefault();
    var SwapPosition = 'primary';
    var parent = $(this).parents(".modelNav")[0];
    var product = getProduct($(this).data('model'))[0];
    if ($(this).hasClass('modelYear__year--active')) {
      return;
    } else {
      $(parent).find('.modelYear__year--active').removeClass('modelYear__year--active');
      SwapPosition = $(this).data('modelorder');
      $(parent).find('.' + SwapPosition + 'Product').addClass('modelYear__year--active');
    }
    $(parent).find('.menu_image').attr("src", product[SwapPosition][0].menu_image).load();
    $(parent).find('.msrp').text(product[SwapPosition][0].msrp);
    $(parent).find('.videoWrapper').css({ 'background-image': 'url(' + product[SwapPosition][0].menu_still + ')' });
    //video player
    $(parent).find('#videoPreload').replaceWith("<link rel=\"preload\" as=\"video\" id=\"videoPreload\"  href=\"" + product[SwapPosition][0].menu_video + "\">");
    $(parent).find('#jsVideoPlayer').replaceWith("<video id=\"jsVideoPlayer\" style=\"\" loop muted data-videourl=\"" + product[SwapPosition][0].menu_video + "\"><source src=\"" + product[SwapPosition][0].menu_video + "\" type=\"video/mp4\"></source></video>");
    var video = $(parent).find("#jsVideoPlayer");
    //video.find("source").attr("src", product[SwapPosition][0].menu_video);
    video.get(0).load();
    video.get(0).play();
    $(parent).find(".coachYear").text(product[SwapPosition][0].year);
    $(parent).find(".content__cta").attr("href", product[SwapPosition][0].page.link);
    $(parent).find(".overlayContent").attr("href", product[SwapPosition][0].page.link);
    $(parent).find(".model-floorplan").attr("href", product[SwapPosition][0].page.link + "floorplans");
    $(parent).find(".model-brochure").attr("href", product[SwapPosition][0].page.link + "brochure");
  });
  function setActive(el) {
    $('.topNav__link').removeClass('topNav__link--active');
    $(el).addClass('topNav__link--active');
  }
});

},{}],5:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-coach-subnav-toggle').each(function () {
      $(this).click(function (e) {
        e.preventDefault();
        $(this).parents('.m-coach-subnav').find('ul').slideToggle(400);
        $(this).toggleClass('is-open');
      });
    });
  });
});

},{}],6:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('html').waypoint(function (d) {
      if (d === 'down') {
        $('.scroll-to-top').velocity({
          opacity: 1,
          translateX: [0, 30]
        }, {
          duration: 400,
          easing: 'easeInOut',
          display: 'block'
        });
      } else {
        $('.scroll-to-top').velocity({
          opacity: 0,
          translateX: [30, 0]
        }, {
          duration: 400,
          easing: 'easeInOut',
          display: 'none'
        });
      }
    }, {
      offset: -500
    });
    $('.scroll-to-top a').click(function (e) {
      e.preventDefault();
      $('html, body').velocity('scroll', {
        duration: 400
      });
    });
  });
});

},{}],7:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(document).ready(function () {

    $('.m-full-width-content-callout-carousel').slick({
      slidesToShow: 1,
      slidestoScroll: 1,
      dots: true,
      arrows: false,
      autoplay: false,
      infinite: false,
      adaptiveHeight: true
    });
  });
});

},{}],8:[function(require,module,exports){
"use strict";

var coaches = jQuery('.m-header-nav-coaches .clearfix');

jQuery(function ($) {
  $(".coachMobileLineup").on("click", ".productYear__year", function (e) {
    e.preventDefault();
    var parent = $(this).parents(".product");
    var switchTo = $(this).data("modelorder"); //primary or secondary
    var currentSelection = parent.find(".productYear__year--active").data("modelorder");
    var parentProduct = $(parent).data("coachid");
    var session = sessionStorage.getItem("productModels");
    if (session != null && switchTo != currentSelection) {

      currentSelection.removeClass;
      var filter = $.grep(JSON.parse(session), function (n, i) {
        return n.id == parentProduct;
      });
      var modelData = filter[0][switchTo];
      parent.find(".productYear__year--active").removeClass("productYear__year--active");
      parent.find("." + switchTo + "Product").addClass("productYear__year--active");
      parent.find(".productPrice__price").text("Starting at $" + modelData[0].msrp);
      parent.find(".product__image").fadeTo("fast", 0);
      setTimeout(function () {
        parent.find(".product__image img").attr("src", modelData[0].menu_image);
      }, 200);
      parent.find(".product__image").fadeTo("fast", 1);
      parent.find(".modelYear").text(modelData[0].year);
      parent.find(".content__cta").attr("href", modelData[0].page.link);
      parent.find(".model-floorplan").attr("href", modelData[0].page.link + "floorplans");
      parent.find(".model-brochure").attr("href", modelData[0].page.link + "brochure");
      var video = parent.find(".video__background");
      video.find("source").attr("src", modelData[0].menu_video);
      video.get(0).load();
      video.get(0).play();
    }
  });
  $(document).ready(function () {
    $('.m-header-nav-list > li > a').click(function (e) {
      if ($(this).siblings().length) {
        e.preventDefault();
        var dropdown = $(this).siblings('.m-header-nav-list-child');
        hideCoaches();
        if (dropdown.is(':visible')) {
          hideDropdown(dropdown);
        } else {
          showDropdown(dropdown);
          hj('trigger', 'main_menu_show_dropdown_' + $(this).parent().index());
        }
      }
    });
    $('.m-header-nav-coaches > span').click(function (e) {
      e.preventDefault();
      var coaches = $(this).siblings('.clearfix');
      if (coaches.is(':visible')) {
        hideCoaches();
      } else {
        showCoaches();
        if (typeof hj !== "undefined") {
          hj('trigger', 'main_menu_show_coaches');
        }
      }
    });
    $('body').click(function (e) {
      var target = $(e.target);
      if (target.parents('.m-header').length < 1 && !target.hasClass('mapboxgl-marker')) {
        var dropdown = $('.m-header-nav-list-child:visible');
        hideCoaches();
        hideDropdown(dropdown);
      }
    });
  });
});

function showCoaches() {
  jQuery(function ($) {
    hideDropdown($('.m-header-nav-list-child:visible'));
    coaches.velocity("slideDown", { delay: 100, duration: 400 });
  });
}

function hideCoaches() {
  coaches.velocity("slideUp", { delay: 50, duration: 400 }, "easeInSine");
}

function showDropdown(dropdown) {
  jQuery(function ($) {
    hideDropdown($('.m-header-nav-list-child:visible'));
    dropdown.velocity('finish').velocity('slideDown', {
      duration: 400,
      easing: 'easeInOut',
      complete: function complete() {
        dropdown.parents('li').children('a').velocity('scroll', {
          duration: 400,
          easing: 'easeInOut'
        });
      }
    });
  });
}

function hideDropdown(dropdown) {
  if (window.innerWidth >= 1200) {
    dropdown.hide();
  } else {
    dropdown.velocity('finish').velocity('slideUp', {
      duration: 400,
      easing: 'easeInOut'
    });
  }
}
/* Mobile Nav product session storage */

function getProduct(el) {
  var productID = $(el).data("coachid");
  var modelNavStore = sessionStorage.getItem("productModel-" + productID);
  if (modelNavStore == null) {
    makeAjaxRequest(productID).done(function (response) {
      sessionStorage.setItem("productModel-" + productID, JSON.stringify(response));
    });
  }
}
function makeAjaxRequest(productID) {
  var env = document.domain.replace(/\./g, '-');
  var jqxhr = $.getJSON("https://newmar-8c1e.kxcdn.com/" + env + ".json", function () {}).done(function (data) {
    sessionStorage.setItem("productModels", JSON.stringify(data));
  }).fail(function () {
    console.log("json request failed");
  });
  if (productID == null) {} else {
    filter = $.grep(JSON.parse(jqxhr), function (n, i) {
      return n.product_type == productType;
    });
    return filter;
  }
}
function fade(element) {
  var op = 1; // initial opacity
  var timer = setInterval(function () {
    if (op <= 0.1) {
      clearInterval(timer);
      element.style.display = 'none';
    }
    element.style.opacity = op;
    element.style.filter = 'alpha(opacity=' + op * 100 + ")";
    op -= op * 0.1;
  }, 50);
}

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initSlick;
jQuery(function ($) {
  $(document).ready(function () {
    initSlick();
  });
  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    var target = $(e.target).attr('aria-controls');
    console.log(target);
    $('.m-image-toggler-thumbs.slick-initialized').slick('unslick');
    $('.m-image-toggler-images.slick-initialized').slick('unslick');
    var thumbs = $('#' + target).find('.m-image-toggler-thumbs'),
        images = $('#' + target).find('.m-image-toggler-images'),
        length = $('#' + target).find('.m-image-toggler-thumbs .m-image-toggler-thumb').length;
    $('#' + target).find('.m-image-toggler-images').slick({
      infinite: false,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: thumbs,
      draggable: false,
      swipe: false
    });
    $('#' + target).find('.m-image-toggler-thumbs').slick({
      infinite: true,
      arrows: true,
      dots: false,
      slidesToShow: length < 3 ? length : 3,
      asNavFor: images,
      focusOnSelect: true,
      // centerMode:true,
      // centerPadding: $('.m-image-toggler-thumbs').width() / 3 + 'px',
      responsive: [{
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 1
        }
      }]
    });
  });

  if ($(window).width() < 480) {
    var current_tab = $('.t-coaches-design-tab-list ul li.active').text();
    $('.t-coaches-design-current').text(current_tab);

    $('.t-coaches-design-current').click(function () {
      $('.t-coaches-design-tab-list ul').slideDown();
    });
    $('.t-coaches-design-tab-list ul li').click(function (e) {
      console.log(e.target);
      var current_tab = $(e.target).text();
      $('.t-coaches-design-current').text(current_tab);
      $('.t-coaches-design-tab-list ul').slideUp('fast');
    });
  }
});

function initSlick() {
  jQuery(function ($) {
    $('.m-image-toggler').each(function () {
      var thumbs = $(this).find('.m-image-toggler-thumbs'),
          images = $(this).find('.m-image-toggler-images'),
          length = thumbs.find('.m-image-toggler-thumb').length;
      images.slick({
        infinite: true,
        arrows: false,
        dots: false,
        fade: true,
        asNavFor: thumbs,
        draggable: false,
        swipe: false
      });
      thumbs.slick({
        infinite: true,
        arrows: true,
        dots: false,
        slidesToShow: length < 3 ? length : 3,
        asNavFor: images,
        focusOnSelect: true,
        // centerMode:true,
        // centerPadding: $('.m-image-toggler-thumbs').width() / 3 + 'px',
        responsive: [{
          breakpoint: 767,
          settings: {
            dots: true,
            slidesToShow: 1
          }
        }]
      });
    });
  });
}

},{}],10:[function(require,module,exports){
'use strict';

require('./accordion/module-accordion');

require('./coach-subnav/module-coach-subnav');

require('./coach-lineup/module-coach-lineup');

require('./coach-lineup-mobile/module-coach-lineup-mobile');

require('./footer/module-footer');

require('./header/module-header');

require('./reviews/module-reviews');

require('./social-media-callout/module-social-media-callout');

require('./text-form-50-50/module-text-form-50-50');

require('./text-media-50-50/module-text-media-50-50');

require('./image-toggler/module-image-toggler');

require('./full-width-content-callout/module-full-width-content-callout');

},{"./accordion/module-accordion":2,"./coach-lineup-mobile/module-coach-lineup-mobile":3,"./coach-lineup/module-coach-lineup":4,"./coach-subnav/module-coach-subnav":5,"./footer/module-footer":6,"./full-width-content-callout/module-full-width-content-callout":7,"./header/module-header":8,"./image-toggler/module-image-toggler":9,"./reviews/module-reviews":11,"./social-media-callout/module-social-media-callout":12,"./text-form-50-50/module-text-form-50-50":13,"./text-media-50-50/module-text-media-50-50":14}],11:[function(require,module,exports){
'use strict';

jQuery(document).ready(function ($) {
  $('.m-reviews-toggle-more').click(function (e) {
    e.preventDefault();

    var $more = $('.m-reviews-more');

    if ($more.is(':visible')) {
      $more.velocity('slideUp', {
        duration: 400,
        easing: 'easeInOut'
      });
      $(this).text('Load More');
    } else {
      $more.velocity('slideDown', {
        duration: 400,
        easing: 'easeInOut'
      });
      $(this).text('Load Less');
    }
  });
});

},{}],12:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    socialMediaImageHeight();
    socialMediaCalloutSlick();
  });
  $(window).on('load', function () {
    socialMediaContentHeight();

    $('.m-social-media-callout-content').css('opacity', '1');
  });
  $(window).resize(function () {
    socialMediaImageHeight();
    socialMediaContentHeight();
    socialMediaCalloutSlick();
  });
});

function socialMediaImageHeight() {
  jQuery(function ($) {
    var imageWidth = $('.m-social-media-callout-gallery-image').width();
    var imageHeight = imageWidth * 0.71;
    $('.m-social-media-callout-gallery-image').height(imageHeight);
  });
}

function socialMediaContentHeight() {
  jQuery(function ($) {
    var galleryHeight = $('.m-social-media-callout-gallery-wrapper').height();
    $('.m-social-media-callout-content-wrapper').height(galleryHeight);
  });
}

function socialMediaCalloutSlick() {
  jQuery(function ($) {
    $('.m-social-media-callout-gallery').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidestoScroll: 1,
      dots: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 3000
    });
  });
}

},{}],13:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(window).on('load', function () {
    $('.hbspt-form select:visible').each(function () {
      $(this).parents('.hs-form-field').addClass('select');
    });
  });
});

},{}],14:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    textMediaImageHeight();
    textMediaSlick();
    resizeTextMedia();
  });
  $(window).on('load', function () {
    // textMediaContentHeight()

    $('.m-text-media-50-50-content').css('opacity', '1');
    resizeTextMedia();
  });
  $(window).resize(function () {
    textMediaImageHeight();
    // textMediaContentHeight()
    textMediaSlick();
    resizeTextMedia();
  });
});

function textMediaImageHeight() {
  jQuery(function ($) {
    $('.m-text-media-50-50').each(function () {
      var imageWidth = $(this).find('.m-text-media-50-50-gallery-image').width();
      var imageHeight = imageWidth * 0.71;
      $(this).find('.m-text-media-50-50-gallery-image').height(imageHeight);
    });
  });
}

// function textMediaContentHeight() {
//   jQuery(function($) {
//     $('.m-text-media-50-50').each(function() {
//       if( $(this).find('.m-text-media-50-50-gallery .m-text-media-50-50-gallery-image').length > 1 ) {
//         var galleryHeight = $(this).find('.m-text-media-50-50-media-wrapper').height()
//         $(this).find('.m-text-media-50-50-content-wrapper').height(galleryHeight)
//       }
//       else {
//         var mediaHeight = $(this).find('.m-text-media-50-50-media-wrapper').height()
//         $(this).find('.m-text-media-50-50-content-wrapper').height(mediaHeight)
//       }
//     })
//   })
// }

function resizeTextMedia() {
  jQuery(function ($) {
    $('.m-text-media-50-50').each(function () {
      var module = $(this);
      module.css('height', 'auto');
      if (window.innerWidth >= 768) {
        module.removeClass('is-resized');
        var h = module.find('[class*="col-"]').map(function () {
          return $(this).outerHeight();
        }).get();
        var mh = Math.max.apply(null, h) + 70;
        module.css('height', mh);
        module.addClass('is-resized');
      } else {
        module.css('height', 'auto');
        module.removeClass('is-resized');
      }
    });
  });
}

function textMediaSlick() {
  jQuery(function ($) {
    $('.m-text-media-50-50').each(function () {
      if ($(this).find('.m-text-media-50-50-gallery .m-text-media-50-50-gallery-image').length > 1) {
        $(this).find('.m-text-media-50-50-gallery .fade-in').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidestoScroll: 1,
          dots: true,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 3000
        });
      }
    });
  });
}

},{}],15:[function(require,module,exports){
'use strict';

function fadeIn() {
  var element = document.getElementsByClassName('fade-in');
  angular.forEach(element, function (item) {
    var waypoint = new Waypoint({
      element: item,
      handler: function handler(d) {
        if (d === 'down' && jQuery(this.element).css('opacity') == 0) {
          jQuery(this.element).velocity({
            opacity: 1,
            translateY: [0, 30]
          }, {
            duration: 500,
            easing: 'easeInOut'
          });
        }
      },
      offset: '80%'
    });
  });
  Waypoint.refreshAll();
}

var app = angular.module('newmar', ['ngRoute', 'ngSanitize']); // angular init

app.controller('Blog', ['$scope', '$route', '$routeParams', '$location', '$timeout', '$http', function ($scope, $route, $routeParams, $location, $timeout, $http) {

  $scope.$route = $route;
  $scope.$location = $location;
  $scope.$routeParams = $routeParams;

  $scope.dataLoaded = false;
  $scope.nada = false;

  $scope.filters = {
    category: []
  };

  $scope.$on('$routeChangeSuccess', function () {
    jQuery('.blog-filters-list li').removeClass('is-selected');
    if ($routeParams.category) {
      $scope.filters = {
        category: $routeParams.category
      };
      console.log($scope.filters);
      angular.forEach($scope.filters, function (value, key) {
        var filter = key;
        if (Array.isArray(value)) {
          angular.forEach(value, function (childValue) {
            jQuery('.blog-filter[data-filter="' + filter + '"][data-slug="' + childValue + '"]').parents('li').addClass('is-selected');
          });
        } else {
          jQuery('.blog-filter[data-filter="' + filter + '"][data-slug="' + value + '"]').parents('li').addClass('is-selected');
        }
      });
    } else {
      jQuery('.blog-filter-all').parents('li').addClass('is-selected');
      $scope.filters = {
        category: []
      };
    }

    jQuery('.loading-spinner').show();
    $http({
      method: 'GET',
      url: '/wp-json/e3/v1/posts',
      params: {
        'filters': $scope.filters,
        'search': $scope.search
      }
    }).then(function (res) {
      $scope.ngPosts = res.data; // gather all posts
      console.log($scope.ngPosts);
      $scope.buffer = angular.copy($scope.ngPosts);
    });
  });

  $scope.$watch('buffer', function () {
    $scope.dataLoaded = false;
    $scope.ind = 0;

    if (typeof $scope.buffer !== 'undefined') {
      // console.log($scope.buffer)
      if ($scope.buffer.length < 1) {
        $scope.nada = true;
        $scope.endOfTheMap = true;
      } else {
        $scope.nada = false;
      }

      $scope.initBlog();

      $timeout(function () {
        $scope.dataLoaded = true;
        jQuery('.loading-spinner').hide();
        console.log($scope.endOfTheMap);
        fadeIn();
      });
    }
  });

  $scope.initBlog = function () {
    if (window.innerWidth >= 768) {
      $scope.cachedPosts = $scope.buffer.slice(0, 9);
      if ($scope.ngPosts.length <= 9) {
        $scope.endOfTheMap = true;
      } else {
        $scope.endOfTheMap = false;
      }
    } else {
      $scope.cachedPosts = $scope.buffer.slice(0, 3);
      if ($scope.ngPosts.length <= 3) {
        $scope.endOfTheMap = true;
      } else {
        $scope.endOfTheMap = false;
      }
    }
  };

  $scope.blogFiltersToggle = function ($event) {
    $event.preventDefault();
    jQuery($event.currentTarget).toggleClass('is-open');
  };

  jQuery(window).resize(function () {
    $scope.initBlog();
    $scope.$apply();
  });

  $scope.filterPosts = function ($event) {
    $event.preventDefault();
    $event.stopPropagation();

    var slug = jQuery($event.target).data('slug');

    if (typeof slug !== 'undefined') {
      $location.path('/blog/category/' + slug);
    } else {
      $location.path('/blog/');
    }

    jQuery('.loading-spinner').show();
  };

  $scope.searchPosts = function () {
    jQuery('.loading-spinner').show();
    $http({
      method: 'GET',
      url: '/wp-json/e3/v1/posts',
      params: {
        'filters': $scope.filters,
        'search': $scope.search
      }
    }).then(function (res) {
      $scope.ngPosts = res.data; // gather all posts
      console.log($scope.ngPosts);
      $scope.buffer = angular.copy($scope.ngPosts);
      $timeout(function () {
        jQuery('.loading-spinner').hide();
      });
    });
  };

  $scope.loadMore = function ($event) {
    // this is what happens when you click `See More` (pagination without reload)
    var r;
    if (window.innerWidth >= 768) {
      r = 9;
      $scope.ind = $scope.ind + 9;
      if ($scope.ind + 9 >= $scope.buffer.length) {
        r = $scope.buffer.length - $scope.ind;
        $scope.endOfTheMap = true; // user has paginated through all results
      }
    } else {
      r = 3;
      $scope.ind = $scope.ind + 3;
      if ($scope.ind + 3 >= $scope.buffer.length) {
        r = $scope.buffer.length - $scope.ind;
        $scope.endOfTheMap = true; // user has paginated through all results
      }
    }
    console.log('Loading');
    console.log($scope.endOfTheMap);
    $scope.cachedPosts = $scope.cachedPosts.concat($scope.buffer.slice($scope.ind, r + $scope.ind));
    jQuery($event.target).blur();
    $timeout(function () {
      fadeIn();
    });
  };

  $scope.scrollToTop = function ($event) {
    jQuery('html, body').velocity('scroll', { duration: 400 });
    jQuery($event.target).blur();
  };
}]). // end blog controller
config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
  // use the right controller when the URL meets certain criteria
  $routeProvider.when('/blog', {
    controller: 'Blog'
  }).when('/blog/category/:category', {
    controller: 'Blog'
  });
  $locationProvider.html5Mode(true); // remove unnecessary `!` and `#` from URLs
}]);

},{}],16:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.t-brochures-archive-choose-year span').on('click', function () {
      $('.t-brochures-archive-year').hide();
      $('.t-brochures-archive-choose-year-msg').hide();
      $('.t-brochures-archive-choose-year span').removeClass('is-selected');
      $(this).addClass('is-selected');
      $(window).scrollTop(0);
      var modelyear = $(this).data('id');
      $('.t-brochures-archive-year[data-id="' + modelyear + '"]').show();
    });
  });
});

},{}],17:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    var settings = {
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      dots: true,
      infinite: false,
      responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    };
    $('.t-brochures-slider-slides').each(function () {
      var length = $(this).find('.t-brochures-slider-slide').length;
      settings.slidesToShow = length > 4 ? 4 : length;
      settings.slidesToScroll = length > 4 ? 4 : length;
      $(this).slick(settings);
    });
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      var target = $(e.target).attr('aria-controls');
      $('.t-brochures-slider-slides.slick-initialized').slick('unslick');
      var slider = $('#' + target).find('.t-brochures-slider-slides'),
          length = slider.find('.t-brochures-slider-slide').length;
      if (length < 4 && window.innerWidth >= 992) {
        slider.css({
          'max-width': (slider.find('img').first().outerWidth() + 30) * length,
          'margin': '0 auto'
        });
      }
      settings.slidesToShow = length > 4 ? 4 : length;
      settings.slidesToScroll = length > 4 ? 4 : length;
      slider.slick(settings);
    });
  });
});

},{}],18:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.t-coach-floorplan-selector-filters li a').click(function (e) {
      e.preventDefault();
      var length = $(this).data('length');
      if (length === 'all') {
        $('.t-coach-floorplan-stage [data-floorplan]').remove();
        $('.t-coach-floorplan-stage').removeClass('has-one').removeClass('has-two');
        $('.t-coach-floorplan-floorplan-inner').removeClass('is-selected');
      }
      if (window.innerWidth <= 767) {
        $('.t-coach-floorplan-selector-filters .m-coach-subnav-toggle').html($(this).text() + '<i class="fa fa-angle-down" aria-hidden="true"></i>');
        $('.t-coach-floorplan-selector-filters ul').slideUp(400);
        $('.t-coach-floorplan-selector-filters .m-coach-subnav-toggle').removeClass('is-open');
      }
      $('.t-coach-floorplan-floorplan').each(function () {
        if (length === 'all') {
          $(this).show();
        } else {
          if ($(this).data('length') !== length) {
            $(this).hide();
          } else {
            $(this).show();
          }
        }
      });
    });
  });
});

var $ = jQuery;

var $topChoices = $('.m-floorplan-grid-choices-top .m-floorplan-grid-choice'),
    $compare = $('.m-floorplan-grid [name="compare[]"]'),
    $choices = $('.m-floorplan-grid-choices'),
    breakpoint = 992;

var StaticLimit = 2;

$(document).on('click', '.custom-popup-image-link', function (e) {
  e.preventDefault();
  var $target = $(e.currentTarget);
  if (window.innerWidth >= 992) {
    $.magnificPopup.open({
      items: {
        src: $target.attr('href')
      },
      type: 'image',
      fixedBgPos: true,
      fixedContentPos: true,
      midClick: true
    }, 0);
  } else {
    window.open($target.attr('href'));
  }
});

$(document).ready(function () {

  var $checked = $compare.filter(':checked'),
      $floorplansStage = $('.m-floorplan-grid-floorplans');

  if ($checked.length) addChoices();

  $(document).on('change', '.m-floorplan-grid [name="compare[]"]', function () {
    return addChoices();
  });

  // listen for changes to DOM subtree
  // AKA when floorplan filters are selected
  // Create an observer instance linked to the callback function
  var observer = new MutationObserver(function (mutationsList) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var mutation = _step.value;

        if (mutation.type == 'childList') {
          $compare = $('.m-floorplan-grid [name="compare[]"]');
          removeChoices();
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  });

  // Start observing the target node for configured mutations
  if ($floorplansStage.length) {
    observer.observe($floorplansStage[0], { childList: true });
  }

  $(document).on('click', '.m-floorplan-grid-choice-close', function (e) {
    e.preventDefault();
    var $this = $(e.currentTarget),
        $wrapper = $this.parents('.m-floorplan-grid-choice, .t-coach-floorplan-image-wrapper');
    $compare.filter('[value="' + ($wrapper.data('id') || $wrapper.data('floorplan')) + '"]').prop('checked', false);
    addChoices();
  });

  $('.m-floorplan-grid-choices-compare').click(function (e) {
    e.preventDefault();
    var $checked = $compare.filter(':checked'),
        $stage = $('.t-coach-floorplan-stage');

    // redirectToSpecsTable(e, $checked)

    $stage.show();
    $choices.removeClass('is-active');
    $stage.velocity('scroll', { duration: 250 });
  });

  $('.m-floorplan-grid-choices-clear').click(function (e) {
    e.preventDefault();
    $compare.prop('checked', false);
    removeChoices();
    $choices.removeClass('is-expanded');
  });

  $(window).resize(function () {
    disableOverLimit();
  });
});

/*
==========================================================================
add choices
==========================================================================
*/
function addChoices() {
  $choices.addClass('is-active');

  disableOverLimit();

  removeChoices();

  var $checked = $compare.filter(':checked');
  $checked.each(function (i, item) {
    return addChoice(i, item);
  });

  if ($checked.length === StaticLimit) {
    $('.m-floorplan-grid-choices-compare').show();
  } else {
    $('.m-floorplan-grid-choices-compare').hide();
  }
}

/*
==========================================================================
add choice
==========================================================================
*/
function addChoice(i, item) {
  var $item = $(item),
      id = $item.val(),
      $fp = $('.t-coach-floorplan-floorplan[data-slug="' + id + '"]'),
      year = $('.t-coach-floorplan-floorplans').data('productyear'),
      coach = $('.t-coach-floorplan-floorplans').data('productcoach'),
      $img = $fp.find('img.t-coach-floorplan-image'),
      name = $fp.find('.t-coach-floorplan-number').text(),
      img = '<img class="hvcenter" src="' + $img.attr('src') + '" alt="' + $img.attr('alt') + '">',
      p = '<p class="p3 hvcenter black">' + name + '</p>',
      close = '<button class="t-coach-floorplan-image-close m-floorplan-grid-choice-close button-reset">&times;<span class="sr-only">Remove choice</span></button>',
      $overlay = $('<div class="he-overlay" />').append(close).append(p),
      $stage = $('.t-coach-floorplan-stage'),
      $wrapper = $('.t-coach-floorplan-image-wrapper[data-floorplan="' + id + '"]'),
      $wrapperClone = $wrapper.clone(),
      title = '<p class="text-center"><strong>' + year + ' ' + coach + ' ' + name + '</strong></p>';

  $wrapperClone.removeClass('col-sm-12 col-md-8 col-lg-8');
  var $imgVarForTooltip = $wrapperClone.find('img'),
      $tooltip = $('.t-coach-floorplan-tooltip');
  console.log($wrapper);
  $imgVarForTooltip.on('mousemove', function (e) {
    $tooltip.css({ top: e.pageY, left: e.pageX });
    $tooltip.tooltip('show');
  });

  $imgVarForTooltip.on('mouseleave', function () {
    $tooltip.tooltip('hide');
  });

  var $image = $wrapperClone.append(close).append(title);
  $stage.append($image);

  $topChoices.eq(i).find('p').text('').addClass('is-checked');
}

/*
==========================================================================
remove choices
==========================================================================
*/
function removeChoices() {
  for (var i = 0; i < StaticLimit; i++) {
    removeChoice(i);
  }
  $('.t-coach-floorplan-stage').html('').hide();
}

/*
==========================================================================
remove choice
==========================================================================
*/
function removeChoice(i) {
  $topChoices.eq(i).find('p').removeClass('is-checked').text(i + 1);
  var $p = $('<p class="h1 silver vcenter" />');
  $p.text(i + 1);
}

/*
==========================================================================
disable over limit
==========================================================================
*/
function disableOverLimit() {
  var $checked = $compare.filter(':checked'),
      length = $checked.length;

  $compare.prop('disabled', false);
  if (length >= StaticLimit) {
    $compare.not(':checked').prop('disabled', true);
  }
}

},{}],19:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    var $grid = $('.t-coach-gallery-grid').imagesLoaded(function () {
      $grid.masonry({
        itemSelector: '.t-coach-gallery-grid-image',
        percentPosition: true,
        columnWidth: '.t-coach-gallery-grid-sizer'
      });
    });

    $('.t-coach-gallery-paginate').click(function (e) {
      e.preventDefault();
      $('.t-coach-gallery-grid-image:visible:last').nextAll('*:lt(2)').show();
      $grid.masonry();
      if ($('.t-coach-gallery-grid-image:last').is(':visible')) {
        $('.t-coach-gallery-paginate').hide();
      }
    });
  });
});

},{}],20:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.panel-collapse').on('shown.bs.collapse', function () {
      if ($(this).find('.swipe-table').length) {
        $(this).find('.swipe-table').trigger('enhance.tablesaw');
      }
    });
  });
});

},{}],21:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.t-coach-paint-selector-images').slick({
      infinite: false,
      arrows: false,
      dots: false,
      asNavFor: '.t-coach-paint-selector-swatches',
      fade: true
    });
    $('.t-coach-paint-selector-swatches').slick({
      infinite: false,
      arrows: false,
      dots: false,
      slidesToShow: $('.t-coach-paint-selector-swatches > div').length,
      asNavFor: '.t-coach-paint-selector-images',
      focusOnSelect: true
    });
    $('.t-coach-pano').click(function () {
      $(this).find('iframe').addClass('is-active');
    }).mouseleave(function () {
      $(this).find('iframe').removeClass('is-active');
    });
  });
});

},{}],22:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.t-dealer-resources-choose-year').on('change', function () {
      $('.t-dealer-resources-brochures').hide();
      $('.t-dealer-resources-brochures[data-id="' + $(this).val() + '"]').show();
    });
  });
});

},{}],23:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    var prodNumberField = $('.t-dealer-warranty #input_1_15');
    checkForRecall(prodNumberField);
    prodNumberField.blur(function () {
      checkForRecall($(this));
    });
  });
});

function checkForRecall(element) {
  var val = element.val();
  if (!val) {
    return;
  }
  jQuery('.loading-spinner').show();
  jQuery.get('/wp-json/e3/v1/soap-recall', {
    prodNumber: val
  }, function (data) {
    jQuery('.loading-spinner').hide();
    console.log(data);
    element.parents('.gfield').find('.alert').remove();
    if (data.recall.successful || data.recall.messages.item.messageText.indexOf('Multiple objects returned') !== -1) {
      var alert = '<div class="alert alert-danger alert-dismissible" role="alert">\n        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n        <strong>Warning:</strong>\n        ' + val + ' is subject to an open recall. For a complete list of open recalls, visit the <b>Recalls</b> section under the <b>Coach Inquiry</b> tab in NewPar, or contact your Newmar Service Account Manager.\n      </div>';
      element.parents('.gfield').append(alert);
    }
  });
}

},{}],24:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    relatedImageHeight();
    relatedPostsSlick();
    slickDotsLocation();

    $('.m-related-content-post a').hover(function (e) {
      $(e.target).parents('.m-related-content-post').toggleClass('hover');
    });

    // open social share links in a new, baby window
    $('.social-share-icon a').click(function (e) {
      e.preventDefault();
      window.open($(this).attr('href'), 'ShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
      return false;
    });

    if ($(window).width() < 768) {
      if ($('body').hasClass('single') && $('.social-share').length > 0) {
        var stickyIcons = $('.social-share').offset().top;
        stickyIcons = stickyIcons;

        var stickyShare = function stickyShare() {
          var scrollTop = $(window).scrollTop();

          if (scrollTop > stickyIcons) {
            $('.social-share').addClass('sticky');
          } else {
            $('.social-share').removeClass('sticky');
          }
        };
        stickyShare();
        $(window).scroll(function () {
          stickyShare();
        });
      }
    }
  });
  $(window).on('load', function () {
    relatedImageHeight();
    slickDotsLocation();
  });
  $(window).resize(function () {
    relatedImageHeight();
    slickDotsLocation();
  });
});

function relatedImageHeight() {
  jQuery(function ($) {
    if ($('.m-related-content-post .bg-image').length) {
      var imageWidth = $('.m-related-content-post .bg-image').width();
      console.log(imageWidth);
      $('.m-related-content-post .m-related-content-image').height(imageWidth);
      $('.m-related-content-post .bg-image').height(imageWidth);
    }
  });
}

function relatedPostsSlick() {
  jQuery(function ($) {
    $('.m-related-content-posts').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: true,
      infinite: false,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  });
}

function slickDotsLocation() {
  jQuery(function ($) {
    var imageHeight = $('.m-related-content-post .bg-image').height();
    var top = imageHeight + 30;
    $('.m-related-content .slick-dots').css('top', top);
  });
}

},{}],25:[function(require,module,exports){
'use strict';

require('./blog/template-blog');

require('./brochures/template-brochures');

require('./brochures-archive/template-brochures-archive');

require('./coach/template-coach');

require('./coach-floorplan/template-coach-floorplan');

require('./coach-gallery/template-coach-gallery');

require('./coach-specs/template-coach-specs');

require('./dealer-resources/template-dealer-resources');

require('./dealer-warranty/template-dealer-warranty');

require('./single/single');

require('./tool-build/template-tool-build');

require('./tool-compare/template-tool-compare');

},{"./blog/template-blog":15,"./brochures-archive/template-brochures-archive":16,"./brochures/template-brochures":17,"./coach-floorplan/template-coach-floorplan":18,"./coach-gallery/template-coach-gallery":19,"./coach-specs/template-coach-specs":20,"./coach/template-coach":21,"./dealer-resources/template-dealer-resources":22,"./dealer-warranty/template-dealer-warranty":23,"./single/single":24,"./tool-build/template-tool-build":26,"./tool-compare/template-tool-compare":27}],26:[function(require,module,exports){
'use strict';

var _moduleImageToggler = require('../../modules/image-toggler/module-image-toggler');

var _moduleImageToggler2 = _interopRequireDefault(_moduleImageToggler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inProgress = false;

jQuery(function ($) {
  $(document).ready(function () {
    var header = $('.m-header');
    header.waypoint(function (d) {
      var control = $('.t-tool-build-control-js'),
          subnav = $('.t-tool-build-subnav-js');
      if (window.innerWidth <= 991) {
        subnav = $('.t-tool-build-subnav-js-mobile');
      }
      if (d == 'down') {
        control.addClass('is-fixed');
        subnav.css('margin-top', control.outerHeight());
      } else {
        control.removeClass('is-fixed');
        subnav.css('margin-top', 0);
      }
    }, {
      offset: -header.outerHeight() - $('.t-tool-build-prev-mobile').outerHeight()
    });
  });
});

var app = angular.module('buildACoach', ['ngRoute', 'ngSanitize', 'LocalStorageModule']); // angular init

app.controller('Main', ['$scope', '$rootScope', '$route', '$routeParams', '$timeout', '$location', '$http', 'localStorageService', function ($scope, $rootScope, $route, $routeParams, $timeout, $location, $http, localStorageService) {

  $rootScope.selectedOptions = {};

  $scope.basePath = '/shopping-tools/build-a-motorcoach/';

  $scope.pages = {
    1: 'start',
    2: 'floorplan',
    3: 'exterior',
    4: 'decor',
    5: 'cabinetry',
    6: 'options',
    7: 'complete'
  };

  var inverseMap = {};

  for (var page in $scope.pages) {
    if (!Object.prototype.hasOwnProperty.call($scope.pages, page)) continue;
    inverseMap[$scope.pages[page]] = page;
  }

  $scope.inversePages = inverseMap;

  $scope.$on('$routeChangeSuccess', function () {

    jQuery('.loading-spinner').show();

    $rootScope.selectionMade = false;
    $scope.coach = $routeParams.coach;

    $timeout(function () {
      jQuery('.t-tool-build-next a').blur();
      jQuery('.m-image-toggler').hide();
      if ($rootScope.page == 'options') {
        $rootScope.selectionMade = true; // auto-show the `next` button on the `options` page
        jQuery('.t-tool-build-next a').attr('href', $scope.basePath + $scope.coach + '/complete/');
      }
      if ($rootScope.page == 'start') {
        $rootScope.floorplanNum = null;
        localStorageService.clearAll();
      }
      jQuery('.t-tool-build-subnav a, .t-tool-build-subnav-mobile a').removeClass('is-active').removeClass('is-complete');
      jQuery('.t-tool-build-subnav a, .t-tool-build-subnav-mobile a').each(function () {
        if ($scope.pages[jQuery(this).data('step')] == $rootScope.page) {
          jQuery(this).addClass('is-active');
        }
        if (jQuery(this).data('page') != 'start') {
          if (parseInt($scope.inversePages[$rootScope.page]) >= jQuery(this).data('step')) {
            jQuery(this).prop('disabled', false).removeClass('is-disabled').attr('href', $scope.basePath + $scope.coach + '/' + jQuery(this).data('page') + '/');
          } else {
            jQuery(this).prop('disabled', true).addClass('is-disabled').attr('href', '#');
          }
        }
      });
      jQuery('.t-tool-build-subnav-mobile a').each(function () {
        if (parseInt($scope.inversePages[$rootScope.page]) > jQuery(this).data('step')) {
          jQuery(this).addClass('is-complete');
        } else {
          jQuery(this).removeClass('is-complete');
        }
      });
      $scope.$watch('selectionMade', function () {
        if ($rootScope.selectionMade == false || $rootScope.page == 'complete') {
          jQuery('.page-template-template-tool-build').css('padding-bottom', 0);
          jQuery('.scroll-to-top').css('bottom', 15);
        } else {
          jQuery('.page-template-template-tool-build').css('padding-bottom', 106);
          jQuery('.scroll-to-top').css('bottom', 121);
        }
      });
    });
    Waypoint.refreshAll();
  });

  $scope.scrollToTop = function () {
    if (window.innerWidth <= 767) {
      jQuery('.t-tool-build-stage').velocity('scroll', {
        duration: 400,
        easing: 'easeInOut',
        offset: -jQuery('.t-tool-build-control').outerHeight()
      });
    }
  };

  $scope.selectCoach = function (e) {
    e.preventDefault();
    var target = jQuery(e.currentTarget);
    if (target.attr('disabled') == 'disabled') {
      return;
    }
    jQuery('.m-coach-lineup-coach > a').removeClass('is-selected');
    target.toggleClass('is-selected');
    if (target.hasClass('is-selected')) {
      $scope.coach = target.data('coach');
      $rootScope.selectionMade = true;
      var page = 'floorplan';
      jQuery('.t-tool-build-next a').attr('href', $scope.basePath + $scope.coach + '/' + page + '/');
    } else {
      $scope.coach = '';
      $rootScope.selectionMade = false;
    }
  };

  $scope.selectImage = function (target) {
    target = jQuery(target);
    jQuery('.m-image-toggler-thumb').removeClass('is-selected');
    target.addClass('is-selected');

    $rootScope[$rootScope.page] = target.data('id');
    $rootScope.selectionMade = true; // set to true to display the `next` button
    var page = $scope.pages[parseInt($scope.inversePages[$rootScope.page]) + 1]; // get the next page from $scope.pages
    jQuery('.t-tool-build-next a').attr('href', $scope.basePath + $scope.coach + '/' + page + '/'); // set href of `next` button

    if ($rootScope.page == 'floorplan') {
      getAndSetBasePrice($scope, $rootScope, $http, $location, localStorageService, $timeout);
      $timeout(function () {
        $rootScope.selectedOptions = {};
        localStorageService.remove('options');
      });
    } else {
      addPriceToTotal($rootScope, $http, localStorageService, $timeout, target.data('item-number'));
    }
  };

  $scope.nextPage = function (e) {
    e.preventDefault();
    var target = jQuery(e.currentTarget),
        s = $location.search() ? $location.search() : {};
    if (target.attr('disabled') == 'disabled') {
      return;
    }
    s[$rootScope.page] = $rootScope[$rootScope.page];
    $location.path(target.attr('href')).search(s);
  };

  $scope.jumpPage = function (e) {
    e.preventDefault();
    var target = jQuery(e.currentTarget),
        s = $location.search() ? $location.search() : {};
    if (target.prop('disabled') == true) {
      return;
    }
    if (target.data('page') != 'start') {
      $location.path(target.attr('href')).search(s);
    } else {
      // console.log('exception')
      $location.path(target.attr('href')).search({});
    }
  };
}]).controller('Start', ['$scope', '$rootScope', '$timeout', '$http', function ($scope, $rootScope, $timeout, $http) {

  $rootScope.page = 'start';
  $rootScope.floorplan = null;

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-lineup'
  }).then(function (res) {

    $scope.product_types = res.data;
    $timeout(function () {
      jQuery('.loading-spinner').hide();
      jQuery('.t-tool-build-control .t-tool-build-next').css('opacity', 1);
    });
  });
}]).controller('ImageToggler', ['$scope', '$rootScope', '$route', '$routeParams', '$http', '$timeout', '$location', 'localStorageService', function ($scope, $rootScope, $route, $routeParams, $http, $timeout, $location, localStorageService) {

  $scope.coach = $routeParams.coach;
  $scope.floorplan = $routeParams.floorplan;
  $rootScope.page = $routeParams.page;

  if ($rootScope.page === undefined) {
    $location.path($scope.basePath + $scope.coach + '/floorplan/');
  }

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-tool-build',
    params: {
      coach: $scope.coach,
      page: $rootScope.page,
      floorplan: $scope.floorplan
    }
  }).then(function (res) {

    $rootScope.coachData = $scope.coachData = res.data;

    $timeout(function () {
      getAndSetBasePrice($scope, $rootScope, $http, $location, localStorageService, $timeout);
      addPriceToTotal($rootScope, $http, localStorageService, $timeout);

      var thumbs = jQuery('.m-image-toggler-thumbs'),
          options = localStorageService.get('options');

      thumbs.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var target = '.m-image-toggler-thumb[data-id="' + nextSlide + '"]';
        if (currentSlide !== null && currentSlide !== nextSlide && localStorageService.get('options') && localStorageService.get('options').length > 0) {
          // TODO: fix this; it doesn’t run if <= 3 slides
          // and we need it to pop off the old selection
          var old = '.m-image-toggler-thumb[data-id="' + currentSlide + '"]',
              options = localStorageService.get('options'),
              index = options.indexOf(jQuery(old).data('item-number'));
          if (index !== -1) {
            options.splice(index, 1);
            localStorageService.set('options', options);
          }
        }
        $scope.selectImage(target);
        $scope.$apply();
      });

      jQuery('.m-image-toggler').show();
      (0, _moduleImageToggler2.default)();

      // select image from localstorage
      if (options && options.length > 0) {
        for (var option in options) {
          var target = '[data-item-number="' + options[option] + '"]';
          if (jQuery(target).length) {
            jQuery('.m-image-toggler-images').slick('slickGoTo', jQuery(target).data('id')); // move to selected image
            $scope.selectImage(target);
            $scope.$apply();
          }
        }
      }

      if ($rootScope.page == 'exterior') {
        jQuery('.m-image-toggler-images .bg-image').each(function () {
          jQuery(this).css('background-size', 'contain');
        });
      }
      if ($rootScope.page == 'floorplan') {
        jQuery('.m-image-toggler .bg-image').each(function () {
          jQuery(this).css('background-size', 'contain');
        });
      }
      if ($rootScope.page == 'decor') {
        jQuery('.m-image-toggler-images .bg-image').each(function () {
          if (window.innerWidth >= 768) {
            jQuery(this).css('height', '500px');
          } else {
            jQuery(this).css('height', '250px');
          }
        });
      }
      if ($rootScope.page == 'cabinetry') {
        jQuery('.m-image-toggler-images .bg-image').each(function () {
          jQuery(this).css('background-position', 'top left');
        });
      }

      $scope.scrollToTop();
      jQuery('.loading-spinner').hide();
      jQuery('.t-tool-build-control .t-tool-build-next').css('opacity', 1);

      if ($location.search()) {

        var s = $location.search();
        jQuery('.m-image-toggler-thumb').each(function () {

          if (jQuery(this).data('id') == s[$rootScope.page]) {

            jQuery('.m-image-toggler-images').slick('slickGoTo', jQuery(this).data('id')); // move to selected image

            if (jQuery(this).hasClass('slick-current')) {
              $scope.selectImage(this);
            }
            $scope.$apply();
          }
        });
      }
    });
  });
}]).controller('Options', ['$scope', '$rootScope', '$route', '$routeParams', '$http', '$timeout', '$location', 'localStorageService', function ($scope, $rootScope, $route, $routeParams, $http, $timeout, $location, localStorageService) {

  $scope.coach = $routeParams.coach;
  $scope.floorplan = $routeParams.floorplan;
  $rootScope.page = 'options';

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-tool-build',
    params: {
      coach: $scope.coach,
      page: $rootScope.page,
      floorplan: $scope.floorplan
    }
  }).then(function (res) {

    $rootScope.coachData = $scope.coachData = res.data;

    $timeout(function () {
      getAndSetBasePrice($scope, $rootScope, $http, $location, localStorageService, $timeout);
      addPriceToTotal($rootScope, $http, localStorageService, $timeout);

      $scope.scrollToTop();
      jQuery('.loading-spinner').hide();

      jQuery(function ($) {
        $('.m-accordion-row').on('shown.bs.collapse', function () {
          var panel = $(this).find('.panel.panel-default > .panel-collapse.in'),
              offset = panel.offset();
          if (offset) {
            panel.velocity('scroll', {
              duration: 400,
              offset: -panel.parents('.panel').find('.panel-heading').outerHeight() - $('.t-tool-build-control').outerHeight()
            });
          }
        });
      });

      jQuery('.t-tool-build-control .t-tool-build-next').css('opacity', 1);

      if (localStorageService.get('options')) {
        var options = localStorageService.get('options');
        options.forEach(function (item) {
          $rootScope.selectedOptions[item] = true;
        });
      }

      $scope.addPriceToTotal = function (itemNumber) {
        jQuery('.t-tool-build-checkbox').prop('disabled', true);
        if (itemNumber) {
          addPriceToTotal($rootScope, $http, localStorageService, $timeout, itemNumber, true);
        }
      };
    });
  }).catch(function (e) {
    // console.log(e)
  });
}]).controller('Complete', ['$scope', '$rootScope', '$route', '$routeParams', '$http', '$timeout', '$location', 'localStorageService', function ($scope, $rootScope, $route, $routeParams, $http, $timeout, $location, localStorageService) {

  $scope.coach = $routeParams.coach;
  $scope.floorplan = $routeParams.floorplan;
  $rootScope.page = 'complete';

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-tool-build',
    params: {
      coach: $scope.coach,
      page: $rootScope.page,
      floorplan: $scope.floorplan
    }
  }).then(function (res) {

    $rootScope.coachData = $scope.coachData = res.data;
    $timeout(function () {
      getAndSetBasePrice($scope, $rootScope, $http, $location, localStorageService, $timeout);
      addPriceToTotal($rootScope, $http, localStorageService, $timeout);

      $scope.scrollToTop();
      jQuery('.loading-spinner').hide();
      jQuery('.page-template-template-tool-build').css('padding-bottom', 0);
      jQuery('.t-tool-build-control .t-tool-build-next').css('opacity', 0);

      if (localStorageService.get('options')) {
        var options = localStorageService.get('options');
        options.forEach(function (item) {
          $rootScope.selectedOptions[item] = true;
        });
      }
    });
  }).catch(function (e) {
    // console.log(e)
  });
  $scope.emailBuild = function (e) {
    e.preventDefault();
    var buildButton = document.getElementById('emailButton');
    buildButton.innerHTML = "Fetching Your Build";
    buildButton.setAttribute("disabled", "disabled");
    var hash = Math.round(+new Date() / 1000);
    var coachName = localStorageService.get('coach');
    var coachYear = localStorageService.get('model_year');
    var keyCdnPath = 'https://newmar-8c1e.kxcdn.com/builds/';
    var fullPdfPath = keyCdnPath + 'newmar-' + coachYear + '-' + coachName + '-' + hash + '.pdf';
    //SET POST VARIABLES
    var selectedOptions = Object.keys($rootScope.selectedOptions).map(function (k) {
      return k;
    }).join(',');
    var price = localStorageService.get('price');
    var postVars = {
      selectedOptions: selectedOptions,
      price: price
    };
    console.log("postVars", postVars);

    fetch('/print-your-coach/' + window.location.search + '&coach=' + $scope.coach + '&floorplanNum=' + $rootScope.floorplanNum + '&hash=' + hash, {
      method: 'POST',
      body: JSON.stringify(postVars)
    }).then(function (data) {
      document.getElementById('emailForm').style.display = 'block';
      buildButton.innerHTML = "Email My Build";
      buildButton.removeAttribute("disabled");
      document.getElementById('coachName').innerText = coachName.replace('-', ' ');
    });
    document.querySelectorAll("input[name=floor_plan_id]")[0].value = localStorageService.get('floorplanNum');
    document.querySelectorAll("input[name=coach_brand_i_e_dutch_star]")[0].value = coachName;
    document.querySelectorAll("input[name=bac_results_url]")[0].value = fullPdfPath;
  };

  $scope.printPdf = function (e) {

    e.preventDefault();
    var target = jQuery(e.target),
        form = document.createElement('form');

    form.target = '_blank';
    form.method = 'post';
    form.action = target.attr('href') + window.location.search + '&coach=' + $scope.coach + '&floorplanNum=' + $rootScope.floorplanNum;

    var price = document.createElement('input');
    price.type = 'text';
    price.name = 'price';
    price.value = localStorageService.get('price');

    var selectedOptions = document.createElement('input');
    selectedOptions.type = 'text';
    selectedOptions.name = 'selectedOptions';

    console.log($rootScope.selectedOptions);
    selectedOptions.value = jQuery.map($rootScope.selectedOptions, function (value, key) {
      if (value === true) return key;
    }).join(',');
    console.log(selectedOptions.value);

    form.appendChild(price);
    form.appendChild(selectedOptions);
    document.body.appendChild(form);
    // console.log(form)


    form.submit();
    form.remove();
    // window.open(
    //   target.attr('href') + window.location.search + '&coach=' + $scope.coach,
    //   '_blank'
    // )
  };
}]).config(['$routeProvider', '$locationProvider', 'localStorageServiceProvider', function ($routeProvider, $locationProvider, localStorageServiceProvider) {
  // use the right controller when the URL meets certain criteria
  var themeUrl = '/wp-content/themes/helium-child',
      viewsPath = '/templates/tool-build/views/',
      viewsUrl = themeUrl + viewsPath,
      toolUrl = '/shopping-tools/build-a-motorcoach/';

  $routeProvider.when(toolUrl, {
    controller: 'Start',
    templateUrl: viewsUrl + 'start.html'
  }).when(toolUrl + ':coach/options/', {
    controller: 'Options',
    templateUrl: viewsUrl + 'options.html'
  }).when(toolUrl + ':coach/complete/', {
    controller: 'Complete',
    templateUrl: viewsUrl + 'complete.html'
  }).when(toolUrl + ':coach/:page/', {
    controller: 'ImageToggler',
    templateUrl: viewsUrl + 'image-toggler.html'
  }).when(toolUrl + ':coach/', {
    controller: 'ImageToggler',
    templateUrl: viewsUrl + 'image-toggler.html'
  });

  $locationProvider.html5Mode(true); // remove unnecessary `!` and `#` from URLs

  localStorageServiceProvider.setPrefix('buildACoach');
}]).filter('objLength', function () {
  return function (object) {
    return Object.keys(object).length;
  };
});

function getAndSetBasePrice($scope, $rootScope, $http, $location, localStorageService, $timeout) {
  $timeout(function () {

    var floorplan = $rootScope.coachData.floorplan;
    if (floorplan == null) {
      var floorplanIndex = $rootScope.floorplan ? $rootScope.floorplan : $location.search().floorplan;
      floorplanIndex = floorplanIndex ? floorplanIndex : 0;
      // console.log('floorplanIndex: ' + floorplanIndex)
      floorplan = $rootScope.coachData.floorplans[floorplanIndex];
    }

    $rootScope.floorplanNum = floorplan.name;
    // console.log('floorplanNum: ' + $rootScope.floorplanNum)

    if (!inProgress && ($scope.coachData.year != localStorageService.get('model_year') || $scope.coach != localStorageService.get('coach') || $rootScope.floorplanNum != localStorageService.get('floorplanNum') || !localStorageService.get('price'))) {
      localStorageService.set('model_year', $scope.coachData.year);
      localStorageService.set('coach', $scope.coach);
      localStorageService.set('floorplanNum', $rootScope.floorplanNum);
      localStorageService.remove('price');
      $rootScope.price = null;
      inProgress = true;
      jQuery('.t-tool-build-price').addClass('is-calculating');
      $http({
        method: 'GET',
        url: '/wp-json/e3/v1/soap-base-price',
        params: {
          modelYear: localStorageService.get('model_year'),
          coach: localStorageService.get('coach'),
          floorplan: localStorageService.get('floorplanNum')
        }
      }).then(function (res) {
        localStorageService.set('price', res.data.price);
        localStorageService.set('basePrice', res.data.price);
        $rootScope.price = localStorageService.get('price');
        inProgress = false;
        jQuery('.t-tool-build-price').removeClass('is-calculating');
      }).catch(function (e) {
        // console.log(e)
      });
    } else {
      $rootScope.price = localStorageService.get('price');
      if (!localStorageService.get('basePrice')) {
        localStorageService.set('basePrice', localStorageService.get('price'));
      }
    }
  });
}

function addPriceToTotal($rootScope, $http, localStorageService, $timeout) {
  var itemNumber = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var features = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;


  $timeout(function () {

    if (!localStorageService.get('price')) return;

    if (!localStorageService.get('options') && itemNumber) {
      localStorageService.set('options', [itemNumber]);
    } else if (itemNumber) {
      var options = localStorageService.get('options'),
          index = options.indexOf(itemNumber);
      if ($rootScope.page != 'options') {
        if (index === -1) {
          options.push(itemNumber);
        }
      } else {
        if ($rootScope.selectedOptions[itemNumber]) {
          if (index === -1) {
            options.push(itemNumber);
          }
        } else {
          if (index !== -1) {
            options.splice(index, 1);
          }
        }
      }
      localStorageService.set('options', options);
    }

    if (!localStorageService.get('options')) return;

    jQuery('.t-tool-build-price').addClass('is-calculating');
    jQuery('.m-image-toggler').parents('.row').first().addClass('is-disabled');

    $http({
      method: 'GET',
      url: '/wp-json/e3/v1/add-price',
      params: {
        basePrice: localStorageService.get('basePrice'),
        options: JSON.stringify(localStorageService.get('options')),
        // modelYear: localStorageService.get('model_year'),
        coach: localStorageService.get('coach'),
        floorplan: localStorageService.get('floorplanNum'),
        features: features
      }
    }).then(function (res) {
      localStorageService.set('price', res.data.price);
      $rootScope.price = res.data.price;
      jQuery('.t-tool-build-price').removeClass('is-calculating');
      $timeout(function () {
        jQuery('.m-image-toggler').parents('.row').first().removeClass('is-disabled');
        jQuery('.t-tool-build-checkbox').prop('disabled', false);
      });
    });
  });
}
function closeModal() {
  document.getElementById('emailForm').style.display = 'none';
}

},{"../../modules/image-toggler/module-image-toggler":9}],27:[function(require,module,exports){
'use strict';

var _moduleAccordion = require('../../modules/accordion/module-accordion');

var _moduleAccordion2 = _interopRequireDefault(_moduleAccordion);

var _moduleImageToggler = require('../../modules/image-toggler/module-image-toggler');

var _moduleImageToggler2 = _interopRequireDefault(_moduleImageToggler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

jQuery(function ($) {
  $(document).ready(function () {});
});

var app = angular.module('compareCoaches', ['ngRoute', 'ngSanitize']); // angular init

app.controller('Main', ['$scope', '$rootScope', '$route', '$routeParams', '$timeout', '$location', function ($scope, $rootScope, $route, $routeParams, $timeout, $location) {

  $scope.basePath = '/shopping-tools/compare-motorcoaches/';

  $scope.pages = {
    1: 'start',
    2: 'exterior',
    3: 'floorplan',
    4: 'floorplan-2',
    5: 'decor',
    6: 'cabinetry',
    7: 'options',
    8: 'complete'
  };

  var inverseMap = {};

  for (var page in $scope.pages) {
    if (!Object.prototype.hasOwnProperty.call($scope.pages, page)) continue;
    inverseMap[$scope.pages[page]] = page;
  }

  $scope.inversePages = inverseMap;

  $scope.$on('$routeChangeSuccess', function () {

    console.log($routeParams);

    jQuery('.loading-spinner').show();

    $rootScope.selectionMade = false;
    $scope.coach1 = $routeParams.coach1;
    $scope.coach2 = $routeParams.coach2;

    $timeout(function () {
      $scope.choice1 = '';
      $scope.choice2 = '';
      jQuery('.t-tool-build-next a').blur();
      jQuery('.m-image-toggler').hide();
      if ($rootScope.page == 'options') {
        $rootScope.selectionMade = true; // auto-show the `next` button on the `options` page
        jQuery('.t-tool-build-next a').attr('href', $scope.basePath + $scope.coach1 + '/' + $scope.coach2 + '/complete/');
      }
      jQuery('.t-tool-build-subnav a, .t-tool-build-subnav-mobile a').removeClass('is-active').removeClass('is-complete');
      jQuery('.t-tool-build-subnav a, .t-tool-build-subnav-mobile a').each(function () {
        if ($scope.pages[jQuery(this).data('step')] == $rootScope.page) {
          jQuery(this).addClass('is-active');
        }
        if (jQuery(this).data('page') != 'start') {
          if (parseInt($scope.inversePages[$rootScope.page]) >= jQuery(this).data('step')) {
            jQuery(this).prop('disabled', false).removeClass('is-disabled').attr('href', $scope.basePath + $scope.coach1 + '/' + $scope.coach2 + '/' + jQuery(this).data('page') + '/');
          } else {
            jQuery(this).prop('disabled', true).addClass('is-disabled').attr('href', '#');
          }
        }
      });
      jQuery('.t-tool-build-subnav-mobile a').each(function () {
        if (parseInt($scope.inversePages[$rootScope.page]) > jQuery(this).data('step')) {
          jQuery(this).addClass('is-complete');
        } else {
          jQuery(this).removeClass('is-complete');
        }
      });
      $scope.$watch('selectionMade', function () {
        if ($rootScope.selectionMade == false || $rootScope.page == 'complete') {
          jQuery('.page-template-template-tool-compare').css('padding-bottom', 0);
          jQuery('.scroll-to-top').css('bottom', 15);
        } else {
          jQuery('.page-template-template-tool-compare').css('padding-bottom', 106);
          jQuery('.scroll-to-top').css('bottom', 121);
        }
      });
    });
  });

  $scope.scrollToTop = function () {
    if (window.innerWidth <= 767) {
      jQuery('.t-tool-compare-stage').velocity('scroll', {
        duration: 400,
        easing: 'easeInOut'
      });
    }
  };

  $scope.selectCoach = function (e) {
    e.preventDefault();
    var target = jQuery(e.currentTarget);
    if (target.attr('disabled') == 'disabled') {
      return;
    }

    var wrapper = jQuery('.t-tool-compare-coach-lineup');

    if (wrapper.hasClass('has-one')) {
      target.toggleClass('is-selected');
      if (target.hasClass('is-selected')) {
        $scope.coach2 = target.data('coach');
        $rootScope.selectionMade = true;
        var page = 'exterior';
        jQuery('.t-tool-build-next a').attr('href', $scope.basePath + $scope.coach1 + '/' + $scope.coach2 + '/' + page + '/');
        wrapper.removeClass('has-one').addClass('has-two');
      } else {
        $scope.coach1 = '';
        $rootScope.selectionMade = false;
        wrapper.removeClass('has-one');
      }
    } else if (wrapper.hasClass('has-two')) {
      if (target.hasClass('is-selected')) {
        target.removeClass('is-selected');
        wrapper.removeClass('has-two').addClass('has-one');
        $scope.coach2 = '';
        $rootScope.selectionMade = false;
      }
    } else {
      target.addClass('is-selected');
      $scope.coach1 = target.data('coach');
      $scope.coach2 = '';
      wrapper.addClass('has-one');
    }
    console.log('coach 1: ' + $scope.coach1);
    console.log('coach 2: ' + $scope.coach2);
  };

  $scope.selectImage = function (e) {
    var page = $scope.pages[parseInt($scope.inversePages[$rootScope.page]) + 1],
        target = jQuery(e.currentTarget),
        id = target.data('id'),
        parent = target.data('parent'),
        selection = jQuery('.m-image-toggler-image[data-id="' + id + '"][data-parent="' + parent + '"]');

    if (target.hasClass('m-image-toggler-image')) {
      target = jQuery('.m-image-toggler-thumb[data-id="' + id + '"][data-parent="' + parent + '"]');
      jQuery('.m-image-toggler-image[data-parent="' + parent + '"]').not('.t-coach-floorplan-floorplan').hide();
      jQuery('.m-image-toggler-thumb[data-parent="' + parent + '"]').removeClass('is-selected');
      if (parent == 0) {
        $scope.choice1 = '';
      } else if (parent == 1) {
        $scope.choice2 = '';
      }
      $rootScope.selectionMade = false;
    } else {
      jQuery('.m-image-toggler-image[data-parent="' + parent + '"]').not('.t-coach-floorplan-floorplan').hide();
      jQuery('.m-image-toggler-thumb[data-parent="' + parent + '"]').removeClass('is-selected');
      target.addClass('is-selected');
      selection.show();
      if (parent == 0) {
        $scope.choice1 = id;
      } else if (parent == 1) {
        $scope.choice2 = id;
      }
      if ($scope.choice1 !== '' && $scope.choice2 !== '') {
        $rootScope.selectionMade = true;
        $rootScope[$rootScope.page + '1'] = $scope.choice1;
        $rootScope[$rootScope.page + '2'] = $scope.choice2;
        jQuery('.t-tool-build-next a').attr('href', $scope.basePath + $scope.coach1 + '/' + $scope.coach2 + '/' + page + '/');
      }
    }

    console.log('choice 1: ' + $scope.choice1);
    console.log('choice 2: ' + $scope.choice2);
  };

  $scope.selectFloorplan = function (target) {
    var page = $scope.pages[parseInt($scope.inversePages[$rootScope.page]) + 1],
        target = jQuery(target),
        id = target.data('id');
    console.log(target);
    if ($rootScope.page === 'floorplan') {
      $scope.choice1 = id;
      if ($scope.choice1 !== '') {
        $rootScope.floorplan1 = $scope.choice1;
        $rootScope.selectionMade = true;
        jQuery('.t-tool-build-next a').attr('href', $scope.basePath + $scope.coach1 + '/' + $scope.coach2 + '/' + page + '/');
      }
    }
    if ($rootScope.page === 'floorplan-2') {
      $scope.choice2 = id;
      if ($scope.choice2 !== '') {
        $rootScope.floorplan2 = $scope.choice2;
        $rootScope.selectionMade = true;
        jQuery('.t-tool-build-next a').attr('href', $scope.basePath + $scope.coach1 + '/' + $scope.coach2 + '/' + page + '/');
      }
    }

    console.log('choice 1: ' + $scope.choice1);
    console.log('choice 2: ' + $scope.choice2);
  };

  $scope.nextPage = function (e) {
    e.preventDefault();
    var target = jQuery(e.currentTarget),
        s = $location.search() ? $location.search() : {};
    if (target.attr('disabled') == 'disabled') {
      return;
    }
    if ($rootScope.page === 'floorplan-2') {
      s.floorplan2 = $rootScope.floorplan2;
    } else {
      s[$rootScope.page + '1'] = $rootScope[$rootScope.page + '1'];
      s[$rootScope.page + '2'] = $rootScope[$rootScope.page + '2'];
    }
    $location.path(target.attr('href')).search(s);
  };

  $scope.jumpPage = function (e) {
    e.preventDefault();
    var target = jQuery(e.currentTarget),
        s = $location.search() ? $location.search() : {};
    if (target.prop('disabled') == true) {
      return;
    }
    if (target.data('page') != 'start') {
      $location.path(target.attr('href')).search(s);
    } else {
      $location.path(target.attr('href')).search({});
    }
  };
}]).controller('Start', ['$scope', '$rootScope', '$timeout', '$http', function ($scope, $rootScope, $timeout, $http) {

  $rootScope.page = 'start';

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-lineup'
  }).then(function (res) {
    console.log(res.data);
    $scope.product_types = res.data;
    $timeout(function () {
      jQuery('.loading-spinner').hide();
    });
  });
}]).controller('MakeSelections', ['$scope', '$rootScope', '$route', '$routeParams', '$http', '$timeout', '$location', function ($scope, $rootScope, $route, $routeParams, $http, $timeout, $location) {

  $scope.coach1 = $routeParams.coach1;
  $scope.coach2 = $routeParams.coach2;
  $rootScope.page = $routeParams.page;

  if ($rootScope.page === undefined) {
    $location.path($scope.basePath + $scope.coach1 + '/' + $scope.coach2 + '/exterior/');
  }

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-tool-compare',
    params: {
      coaches: {
        0: $scope.coach1,
        1: $scope.coach2
      },
      page: $rootScope.page
    }
  }).then(function (res) {
    console.log(res.data);
    $scope.coachData = res.data;
    $timeout(function () {
      if ($rootScope.page == 'exterior') {
        jQuery('.m-image-toggler-image .bg-image').each(function () {
          jQuery(this).css('background-size', 'contain');
        });
      }
      if ($rootScope.page == 'cabinetry') {
        jQuery('.m-image-toggler-image .bg-image').each(function () {
          jQuery(this).css('background-position', 'top left');
        });
      }
      jQuery('.loading-spinner').hide();
      if ($location.search()) {
        var s = $location.search();
        jQuery('.m-image-toggler-thumb').each(function () {
          if (jQuery(this).data('id') == s[$rootScope.page + '1'] && jQuery(this).parents('[data-coach="' + $scope.coach1 + '"]').length || jQuery(this).data('id') == s[$rootScope.page + '2'] && jQuery(this).parents('[data-coach="' + $scope.coach2 + '"]').length) {
            jQuery(this).trigger('click');
          }
        });
      }
    });
  });
}]).controller('Floorplan', ['$scope', '$rootScope', '$route', '$routeParams', '$http', '$timeout', '$location', function ($scope, $rootScope, $route, $routeParams, $http, $timeout, $location) {

  $scope.coach1 = $routeParams.coach1;
  $scope.coach2 = $routeParams.coach2;
  $rootScope.page = 'floorplan';

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-tool-compare',
    params: {
      coaches: {
        0: $scope.coach1,
        1: $scope.coach2
      },
      page: $rootScope.page
    }
  }).then(function (res) {
    console.log(res.data);
    $scope.coachData = res.data;
    $timeout(function () {
      jQuery('.loading-spinner').hide();

      var thumbs = jQuery('.m-image-toggler-thumbs');

      thumbs.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var target = '.m-image-toggler-thumb[data-id="' + nextSlide + '"]';
        $scope.selectFloorplan(target);
        $scope.$apply();
      });

      jQuery('.m-image-toggler').show();
      (0, _moduleImageToggler2.default)();

      if ($location.search()) {
        var s = $location.search();
        jQuery('.m-image-toggler-thumb').each(function () {

          if (jQuery(this).data('id') == s.floorplan1) {

            jQuery('.m-image-toggler-images').slick('slickGoTo', jQuery(this).data('id')); // move to selected image

            if (jQuery(this).hasClass('slick-current')) $scope.selectFloorplan(this);

            $scope.$apply();
          }
        });
      }
    });
  });
}]).controller('Floorplan2', ['$scope', '$rootScope', '$route', '$routeParams', '$http', '$timeout', '$location', function ($scope, $rootScope, $route, $routeParams, $http, $timeout, $location) {

  $scope.coach1 = $routeParams.coach1;
  $scope.coach2 = $routeParams.coach2;
  $rootScope.page = 'floorplan-2';

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-tool-compare',
    params: {
      coaches: {
        0: $scope.coach1,
        1: $scope.coach2
      },
      page: $rootScope.page
    }
  }).then(function (res) {
    console.log(res.data);
    $scope.coachData = res.data;
    $timeout(function () {
      jQuery('.loading-spinner').hide();

      var thumbs = jQuery('.m-image-toggler-thumbs');

      thumbs.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var target = '.m-image-toggler-thumb[data-id="' + nextSlide + '"]';
        $scope.selectFloorplan(target);
        $scope.$apply();
      });

      jQuery('.m-image-toggler').show();
      (0, _moduleImageToggler2.default)();

      if ($location.search()) {
        var s = $location.search();
        jQuery('.m-image-toggler-thumb').each(function () {

          if (jQuery(this).data('id') == s.floorplan2) {

            jQuery('.m-image-toggler-images').slick('slickGoTo', jQuery(this).data('id')); // move to selected image

            if (jQuery(this).hasClass('slick-current')) $scope.selectFloorplan(this);

            $scope.$apply();
          }
        });
      }
    });
  });
}]).controller('Options', ['$scope', '$rootScope', '$route', '$routeParams', '$http', '$timeout', function ($scope, $rootScope, $route, $routeParams, $http, $timeout) {

  $scope.coach1 = $routeParams.coach1;
  $scope.coach2 = $routeParams.coach2;
  $rootScope.page = 'options';

  console.log($scope.coach1);
  console.log($scope.coach2);

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-tool-compare',
    params: {
      coaches: {
        0: $scope.coach1,
        1: $scope.coach2
      },
      page: $rootScope.page
    }
  }).then(function (res) {
    console.log(res.data);
    $scope.coachData = res.data;
    $timeout(function () {
      jQuery('.loading-spinner').hide();
      (0, _moduleAccordion2.default)();
    });
  });
}]).controller('Complete', ['$scope', '$rootScope', '$route', '$routeParams', '$http', '$timeout', '$location', function ($scope, $rootScope, $route, $routeParams, $http, $timeout, $location) {

  $scope.coach1 = $routeParams.coach1;
  $scope.coach2 = $routeParams.coach2;
  $rootScope.page = 'complete';

  $http({
    method: 'GET',
    url: '/wp-json/e3/v1/coach-tool-compare',
    params: {
      coaches: {
        0: $scope.coach1,
        1: $scope.coach2
      },
      page: $rootScope.page
    }
  }).then(function (res) {
    console.log(res.data);
    $scope.coachData = res.data;
    $timeout(function () {
      jQuery('.loading-spinner').hide();
    });
  });

  $scope.printPdf = function (e, coach, choice) {
    e.preventDefault();
    choice = choice + 1;
    var target = jQuery(e.target),
        s = $location.search(),
        exterior = s['exterior' + choice],
        floorplan = s['floorplan' + choice],
        decor = s['decor' + choice],
        cabinetry = s['cabinetry' + choice];
    window.open(target.attr('href') + '?exterior=' + exterior + '&floorplan=' + floorplan + '&decor=' + decor + '&cabinetry=' + cabinetry + '&coach=' + coach, '_blank');
  };
}]).config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
  // use the right controller when the URL meets certain criteria
  var themeUrl = '/wp-content/themes/helium-child',
      viewsPath = '/templates/tool-compare/views/',
      viewsUrl = themeUrl + viewsPath,
      toolUrl = '/shopping-tools/compare-motorcoaches/';
  $routeProvider.when(toolUrl, {
    controller: 'Start',
    templateUrl: viewsUrl + 'start.html'
  }).when(toolUrl + ':coach1/:coach2/floorplan/', {
    controller: 'Floorplan',
    templateUrl: viewsUrl + 'floorplan.html'
  }).when(toolUrl + ':coach1/:coach2/floorplan-2/', {
    controller: 'Floorplan2',
    templateUrl: viewsUrl + 'floorplan.html'
  }).when(toolUrl + ':coach1/:coach2/options/', {
    controller: 'Options',
    templateUrl: viewsUrl + 'options.html'
  }).when(toolUrl + ':coach1/:coach2/complete/', {
    controller: 'Complete',
    templateUrl: viewsUrl + 'complete.html'
  }).when(toolUrl + ':coach1/:coach2/:page/', {
    controller: 'MakeSelections',
    templateUrl: viewsUrl + 'make-selections.html'
  }).when(toolUrl + ':coach1/:coach2/', {
    controller: 'MakeSelections',
    templateUrl: viewsUrl + 'make-selections.html'
  });
  $locationProvider.html5Mode(true); // remove unnecessary `!` and `#` from URLs
}]);

},{"../../modules/accordion/module-accordion":2,"../../modules/image-toggler/module-image-toggler":9}]},{},[1]);
